import React, { useCallback } from 'react';
import { Field } from 'redux-form';
import { OutlinedTextFields, MIDatePicker } from '@Components';
import { dynamic_validator2 } from '../../../../utils/validation';
import { r_maxLength } from '../../../../utils/validation/restrictions';
import moment from 'moment';
import { SUCCESS_MSG } from './uploadDocSG.styles';
import { CORRECT_ICON } from '@Images';

export const GenerateField = (props: {
  field: any;
  getAllformVal: any;
  disableField: boolean;
  resetValue: any;
}): React.ReactElement => {
  const { field, getAllformVal, disableField, resetValue } = props;

  const validateField = useCallback(
    (value: any, allValues: any, props: any, name: string) => {
      let errors;
      //eslint-disable-next-line
      errors = dynamic_validator2(value, field.validations, errors, {
        isCorp: false,
        allValues,
        name
      });
      return errors;
    },
    [field.validations]
  );

  let asyncValidateMsg = getAllformVal?.asyncValidateMsg?.[field.field_name];
  let disbledField = field.disabled || disableField || asyncValidateMsg;

  const getFieldDate = (range: any, type: string) => {
    if (!range) return undefined;
    const { min_identifier, min_offset, max_identifier, max_offset } = range || {};
    const currentDate = moment();
    if (type === 'min' && min_identifier) return currentDate.add(min_offset, min_identifier);
    if (type === 'max' && max_identifier) return currentDate.add(max_offset, max_identifier);
    return undefined;
  };

  switch (field.category) {
    case 'text_field':
      return (
        <div className="updc-input-control-container" key={field.field_name}>
          <div className="icon-div">
            <Field
              key={field.field_name}
              disabled={disbledField}
              name={field.field_name}
              type={field.type}
              fieldClass="updc-input-control"
              component={OutlinedTextFields}
              placeholder={field.label}
              validate={disbledField ? [] : [validateField]}
              onChange={() => resetValue(field.field_name)}
              normalize={
                field.validations && field.validations.length && field.validations.length.max
                  ? r_maxLength(field.validations.length.max)
                  : null
              }
            />
            {asyncValidateMsg && (
              <div className="success_icon">
                <img src={CORRECT_ICON} width="20" alt="correct" />
              </div>
            )}
          </div>
          {asyncValidateMsg && <SUCCESS_MSG id="success-msg">{asyncValidateMsg}</SUCCESS_MSG>}
        </div>
      );
    case 'date_picker':
      return (
        <div className="updc-input-control-container" key={field.field_name}>
          <Field
            key={field.field_name}
            name={field.field_name}
            type={field.type}
            disabled={disbledField}
            parentClassName="full-width"
            component={MIDatePicker}
            formatString="dd/MM/yyyy"
            placeholder={field.label}
            validate={[validateField]}
            minDate={getFieldDate(field.range, 'min')}
            maxDate={getFieldDate(field.range, 'max')}
          />
        </div>
      );
    default:
      return <></>;
  }
};
